export default {
  'standard-residential': {
    name: 'Standard Residential Property',
    description: 'Template for typical residential electrical inspection',
    data: {
      circuits: [
        {
          circuitType: 'Lighting',
          location: 'Downstairs',
          rating: '6A',
          protectiveDevice: 'MCB',
          testResult: '',
          remedialAction: ''
        },
        {
          circuitType: 'Power',
          location: 'Downstairs',
          rating: '32A',
          protectiveDevice: 'RCBO',
          testResult: '',
          remedialAction: ''
        }
      ]
    }
  },
  'commercial-property': {
    name: 'Commercial Property',
    description: 'Template for commercial property electrical inspection',
    data: {
      circuits: [
        {
          circuitType: 'Power',
          location: 'Office Area',
          rating: '32A',
          protectiveDevice: 'RCBO',
          testResult: '',
          remedialAction: ''
        }
      ]
    }
  }
};